module.exports = __webpack_public_path__ + "img/page_3_2.d3b2ea54.png";